import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import constants from './slices/constantsSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        constants,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
